import { algoliasearch } from 'algoliasearch';
import { initAlgoliaSearchAttributionGlobals } from './attribution';

export const ALGOLIA_APP_ID = '1IWZ8YWNNC';
export const ALGOLIA_SEARCH_API_KEY = 'af1887269f31107c9182bfd636e1238d';

export const ALGOLIA_INDICES = {
  products: 'shopify_products',
  querySuggestions: 'shopify_products_query_suggestions',
  popularProducts: 'shopify_products_recently_ordered_count_desc',
  collections: 'shopify_collections',
  articles: 'shopify_articles',
};

export const ALGOLIA_FILTERS = {
  // Rules: no inventory -> hide; remove-search -> hide; search-live -> always show.
  // Written in conjunctive form so both the facetFilters array and the filters string
  // express `tags:search-live OR (NOT tags:remove-search AND inventory_available:true)`.
  hiddenProducts: [
    ['tags:-remove-search', 'tags:search-live'],
    ['inventory_available:true', 'tags:search-live'],
  ],
  hiddenProductsExpression:
    '(NOT tags:"remove-search" OR tags:"search-live") AND (inventory_available:true OR tags:"search-live")',
};

export const ALGOLIA_SEARCH_PAGE_CONFIG = {
  indexName: ALGOLIA_INDICES.products,
  filters: ALGOLIA_FILTERS.hiddenProductsExpression,
  sortBy: [
    {
      label: 'Relevance',
      value: ALGOLIA_INDICES.products,
    },
    {
      label: 'Price (Low to High)',
      value: 'shopify_products_price_low_to_high',
    },
    {
      label: 'Price (High to Low)',
      value: 'shopify_products_price_high_to_low',
    },
  ],
};

export const ALGOLIA_COLLECTION_PAGE_CONFIG = {
  indexName: ALGOLIA_INDICES.products,
  hitsPerPage: 12,
  maxValuesPerFacet: 1000,
  facets: ['*'],
  sortIndices: {
    featured: ALGOLIA_INDICES.products,
    popularity: ALGOLIA_INDICES.popularProducts,
    new: 'shopify_products_recently_ordered_count_desc',
    'price-ascending': 'shopify_products_price_low_to_high',
    'price-descending': 'shopify_products_price_high_to_low',
  },
};

// Same availability rule as search: hide out-of-stock products unless tagged search-live.
export function buildCollectionFilter(collectionHandle) {
  return `collections:"${collectionHandle}" AND (inventory_available:true OR tags:"search-live")`;
}

export function buildCollectionFilters(collectionHandle) {
  return buildCollectionFilter(collectionHandle);
}

export const searchClient = algoliasearch(
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY
);

initAlgoliaSearchAttributionGlobals();
